
//@ts-nocheck
import * as ACDesigner from 'adaptivecards-designer';
import * as AdaptiveCards from 'adaptivecards';
import { StatusPicker, StatusPickerPeer } from '../Pickers/StatusPicker';
import { RequestTitle, RequestTitlePeer } from '../RequestTitle';
import { CategoryPicker, CategoryPickerPeer } from '../Pickers/CategoryPicker';
import { TicketTypePicker, TicketTypePickerPeer } from '../Pickers/TicketTypePicker';
import { PriorityPicker, PriorityPickerPeer } from '../Pickers/PriorityPicker';
import { AffectedUsersPeoplePicker, AffectedUsersPeoplePickerPeer} from '../PeoplePicker/AffectedUsersPeoplePicker';
import { TagsTypeahead, TagsTypeaheadPeer } from '../Typeahead/TagsTypeahead';
import { CollaboratorsTypeahead, CollaboratorsTypeaheadPeer } from '../Typeahead/CollaboratorsTypeahead';
import { RequesterPeoplePicker, RequesterPeoplePickerPeer } from '../PeoplePicker/RequesterPeoplePicker';
import { Assignment, AssignmentPeer } from '../Assignment';
import { TeamPicker, TeamPickerPeer } from '../Pickers/TeamPicker';
import { GroupPicker, GroupPickerPeer } from '../Pickers/GroupPicker';
import { AddComment, AddCommentPeer } from '../AddComment';
import { DueDate, DueDatePeer } from '../Date/DueDate';
import { ResolutionDate, ResolutionDatePeer } from '../Date/ResolutionDate';
import { UploadFile, UploadFilePeer } from '../UploadFile';
import { SubmitRequest, SubmitRequestPeer } from '../SubmitRequest';
import { StatusOfMyRequests, StatusOfMyRequestsPeer } from '../StatusOfMyRequests';
import { TextProperty, TextPropertyPeer } from '../CustomProperties/TextProperty';
import { LICENSE_FEATURE} from '../../../shared/utils/constants';
import { getCachedFeature } from '../../../shared/cache/FeatureCache';
import { CardPeoplePicker, CardPeoplePickerPeer } from '../PeoplePicker/CardPeoplePicker';
import { TicketTemplate } from '../../../shared/interfaces/ticket.interface';
import { NumProperty, NumPropertyPeer } from '../CustomProperties/NumProperty';
import { BoolProperty, BoolPropertyPeer } from '../CustomProperties/BoolProperty';
import { DateProperty, DatePropertyPeer } from '../CustomProperties/DateProperty';
import { AppStateValue } from '../../../AppState';
import { CustomPropertyDataType_LABELS } from '../../../custom-properties/utils/constants';
import { TimeProperty, TimePropertyPeer } from '../CustomProperties/TimeProperty';
import { ListProperty, ListPropertyPeer } from '../CustomProperties/ListProperty';

export interface ACFeatureStates {
    enableAffectedUsers: boolean;
    enableCollaborators: boolean;
    enableMultiDepartment: boolean;
    enableTicketTags: boolean;
    enableTicketTypes: boolean;
    enableCustomForms: boolean;
    enableCustomProperties: boolean;
};

export function initializeDesignerCustomComponents() {

    AddComment.isEndUserPage = false;

    UploadFile.filesToUpload = [];
    UploadFile.message = "";
    UploadFile.messageIsPrivate = false;

    SubmitRequest.hideField = false;
    StatusOfMyRequests.hideField = false;

    CollaboratorsTypeahead.presentInTeams = true;
    TagsTypeahead.presentInTeams = true;
    ListProperty.presentInTeams = true;

    Assignment.defaultGroup = null;
}

export const loadFeatureVars = async () =>{
    const featureResult = await Promise.all([
        getCachedFeature(LICENSE_FEATURE.AffectedUsers),
        getCachedFeature(LICENSE_FEATURE.Collaborators),
        getCachedFeature(LICENSE_FEATURE.MultiDepartment),
        getCachedFeature(LICENSE_FEATURE.TicketTags),
        getCachedFeature(LICENSE_FEATURE.TicketTypes),
        getCachedFeature(LICENSE_FEATURE.CustomForms),
        getCachedFeature(LICENSE_FEATURE.CustomProperties)
    ]);
    
    return {
        enableAffectedUsers: featureResult[0],
        enableCollaborators: featureResult[1],
        enableMultiDepartment: featureResult[2],
        enableTicketTags: featureResult[3],
        enableTicketTypes: featureResult[4],
        enableCustomForms: featureResult[5],
        enableCustomProperties: featureResult[6]
    } as ACFeatureStates;
}

export function registerActionsDesignerCustomComponents(hostContainers: ACDesigner.HostContainer[]) {
    const actionsSectionLabel = 'Ticket Extras';

    AdaptiveCards.GlobalRegistry.elements.register(StatusOfMyRequests.JsonTypeName, StatusOfMyRequests, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(StatusOfMyRequests, StatusOfMyRequestsPeer, actionsSectionLabel, "tikit-acd-myrequests");
    hostContainers[0].elementsRegistry.register(StatusOfMyRequests.JsonTypeName, StatusOfMyRequests, AdaptiveCards.Versions.v1_4);

    AdaptiveCards.GlobalRegistry.elements.register(SubmitRequest.JsonTypeName, SubmitRequest, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(SubmitRequest, SubmitRequestPeer, actionsSectionLabel, "tikit-acd-submit");
    hostContainers[0].elementsRegistry.register(SubmitRequest.JsonTypeName, SubmitRequest, AdaptiveCards.Versions.v1_4);
}

export function registerExtrasDesignerCustomComponents(hostContainers: ACDesigner.HostContainer[]) {
    AdaptiveCards.GlobalRegistry.elements.register(CardPeoplePicker.JsonTypeName, CardPeoplePicker, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(CardPeoplePicker, CardPeoplePickerPeer, "Inputs", "tikit-acd-affecteduser");
    hostContainers[0].elementsRegistry.register(CardPeoplePicker.JsonTypeName, CardPeoplePicker, AdaptiveCards.Versions.v1_4);
}

export function registerDesignerCustomComponents(hostContainers: ACDesigner.HostContainer[], featureSets: ACFeatureStates, templateData: TicketTemplate) {
    const propsSectionLabel = 'Ticket Properties';
    const isFormForDefault = templateData.IsDefault && !featureSets.enableCustomForms;
    initializeDesignerCustomComponents();
    
    AdaptiveCards.GlobalRegistry.elements.register(RequestTitle.JsonTypeName, RequestTitle, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(RequestTitle, RequestTitlePeer, propsSectionLabel, "tikit-acd-request");
    hostContainers[0].elementsRegistry.register(RequestTitle.JsonTypeName, RequestTitle, AdaptiveCards.Versions.v1_4);

    AdaptiveCards.GlobalRegistry.elements.register(RequesterPeoplePicker.JsonTypeName, RequesterPeoplePicker, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(RequesterPeoplePicker, RequesterPeoplePickerPeer, propsSectionLabel, "tikit-acd-user");
    hostContainers[0].elementsRegistry.register(RequesterPeoplePicker.JsonTypeName, RequesterPeoplePicker, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableAffectedUsers || isFormForDefault){
        AdaptiveCards.GlobalRegistry.elements.register(AffectedUsersPeoplePicker.JsonTypeName, AffectedUsersPeoplePicker, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(AffectedUsersPeoplePicker, AffectedUsersPeoplePickerPeer, propsSectionLabel, "tikit-acd-affecteduser");
        hostContainers[0].elementsRegistry.register(AffectedUsersPeoplePicker.JsonTypeName, AffectedUsersPeoplePicker, AdaptiveCards.Versions.v1_4);
    }

    AdaptiveCards.GlobalRegistry.elements.register(StatusPicker.JsonTypeName, StatusPicker, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(StatusPicker, StatusPickerPeer, propsSectionLabel, "tikit-acd-status");
    hostContainers[0].elementsRegistry.register(StatusPicker.JsonTypeName, StatusPicker, AdaptiveCards.Versions.v1_4);
 
    if(featureSets.enableTicketTypes || isFormForDefault){
        AdaptiveCards.GlobalRegistry.elements.register(TicketTypePicker.JsonTypeName, TicketTypePicker, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(TicketTypePicker, TicketTypePickerPeer, propsSectionLabel, "tikit-acd-tickettype");
        hostContainers[0].elementsRegistry.register(TicketTypePicker.JsonTypeName, TicketTypePicker, AdaptiveCards.Versions.v1_4);
    }

    AdaptiveCards.GlobalRegistry.elements.register(CategoryPicker.JsonTypeName, CategoryPicker, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(CategoryPicker, CategoryPickerPeer, propsSectionLabel, "tikit-acd-category");
    hostContainers[0].elementsRegistry.register(CategoryPicker.JsonTypeName, CategoryPicker, AdaptiveCards.Versions.v1_4);
    
    AdaptiveCards.GlobalRegistry.elements.register(PriorityPicker.JsonTypeName, PriorityPicker, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(PriorityPicker, PriorityPickerPeer, propsSectionLabel, "tikit-acd-priority");
    hostContainers[0].elementsRegistry.register(PriorityPicker.JsonTypeName, PriorityPicker, AdaptiveCards.Versions.v1_4);
    
    if(featureSets.enableMultiDepartment || isFormForDefault){
        AdaptiveCards.GlobalRegistry.elements.register(TeamPicker.JsonTypeName, TeamPicker, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(TeamPicker, TeamPickerPeer, propsSectionLabel, "tikit-acd-team");
        hostContainers[0].elementsRegistry.register(TeamPicker.JsonTypeName, TeamPicker, AdaptiveCards.Versions.v1_4);

        AdaptiveCards.GlobalRegistry.elements.register(GroupPicker.JsonTypeName, GroupPicker, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(GroupPicker, GroupPickerPeer, propsSectionLabel, "tikit-acd-group");
        hostContainers[0].elementsRegistry.register(GroupPicker.JsonTypeName, GroupPicker, AdaptiveCards.Versions.v1_4);

        AdaptiveCards.GlobalRegistry.elements.register(Assignment.JsonTypeName, Assignment, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(Assignment, AssignmentPeer, propsSectionLabel, "tikit-acd-user");
        hostContainers[0].elementsRegistry.register(Assignment.JsonTypeName, Assignment, AdaptiveCards.Versions.v1_4);
    }

    if(featureSets.enableCollaborators || isFormForDefault){
        AdaptiveCards.GlobalRegistry.elements.register(CollaboratorsTypeahead.JsonTypeName, CollaboratorsTypeahead, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(CollaboratorsTypeahead, CollaboratorsTypeaheadPeer, propsSectionLabel, "tikit-acd-collaborator");
        hostContainers[0].elementsRegistry.register(CollaboratorsTypeahead.JsonTypeName, CollaboratorsTypeahead, AdaptiveCards.Versions.v1_4);
    }

    AdaptiveCards.GlobalRegistry.elements.register(DueDate.JsonTypeName, DueDate, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(DueDate, DueDatePeer, propsSectionLabel, "tikit-acd-date");
    hostContainers[0].elementsRegistry.register(DueDate.JsonTypeName, DueDate, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableTicketTags || isFormForDefault){
        AdaptiveCards.GlobalRegistry.elements.register(TagsTypeahead.JsonTypeName, TagsTypeahead, AdaptiveCards.Versions.v1_4);
        ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(TagsTypeahead, TagsTypeaheadPeer, propsSectionLabel, "tikit-acd-tag");
        hostContainers[0].elementsRegistry.register(TagsTypeahead.JsonTypeName, TagsTypeahead, AdaptiveCards.Versions.v1_4);
    }

    AdaptiveCards.GlobalRegistry.elements.register(ResolutionDate.JsonTypeName, ResolutionDate, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(ResolutionDate, ResolutionDatePeer, propsSectionLabel, "tikit-acd-date");
    hostContainers[0].elementsRegistry.register(ResolutionDate.JsonTypeName, ResolutionDate, AdaptiveCards.Versions.v1_4);

    AdaptiveCards.GlobalRegistry.elements.register(AddComment.JsonTypeName, AddComment, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(AddComment, AddCommentPeer, propsSectionLabel, "tikit-acd-comment");
    hostContainers[0].elementsRegistry.register(AddComment.JsonTypeName, AddComment, AdaptiveCards.Versions.v1_4);

    AdaptiveCards.GlobalRegistry.elements.register(UploadFile.JsonTypeName, UploadFile, AdaptiveCards.Versions.v1_4);
    ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(UploadFile, UploadFilePeer, propsSectionLabel, "tikit-acd-attachment");
    hostContainers[0].elementsRegistry.register(UploadFile.JsonTypeName, UploadFile, AdaptiveCards.Versions.v1_4);
}

export function registerCustomPropertiesDesignerCustomComponents(hostContainers: ACDesigner.HostContainer[], featureSets: ACFeatureStates, currentState: AppStateValue) {
    const propsSectionLabel = 'Custom Properties';

    const customProperties = currentState?.customProperties ?? [];
    customProperties.forEach(s => {
        switch(CustomPropertyDataType_LABELS[s.DataType]){
            case CustomPropertyDataType_LABELS.STRING:
                TextProperty.JsonTypeName = s.Name;
                TextProperty.ElementId = s.PropertyId;
                TextProperty.defaultLabel = s.Name;
                TextProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(TextProperty.JsonTypeName, TextProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(TextProperty, TextPropertyPeer, propsSectionLabel, "acd-icon-inputText");
                hostContainers[0].elementsRegistry.register(TextProperty.JsonTypeName, TextProperty, AdaptiveCards.Versions.v1_4);
                break;
            case CustomPropertyDataType_LABELS.INT:
                NumProperty.JsonTypeName = s.Name;
                NumProperty.ElementId = s.PropertyId;
                NumProperty.defaultLabel = s.Name;
                NumProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(NumProperty.JsonTypeName, NumProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(NumProperty, NumPropertyPeer, propsSectionLabel, "acd-icon-inputNumber");
                hostContainers[0].elementsRegistry.register(NumProperty.JsonTypeName, NumProperty, AdaptiveCards.Versions.v1_4);
                break;
            case CustomPropertyDataType_LABELS.BOOL:
                BoolProperty.JsonTypeName = s.Name;
                BoolProperty.ElementId = s.PropertyId;
                BoolProperty.defaultLabel = s.Name;
                BoolProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(BoolProperty.JsonTypeName, BoolProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(BoolProperty, BoolPropertyPeer, propsSectionLabel, "acd-icon-inputToggle");
                hostContainers[0].elementsRegistry.register(BoolProperty.JsonTypeName, BoolProperty, AdaptiveCards.Versions.v1_4);
                break;
            case CustomPropertyDataType_LABELS.DATE:
                DateProperty.JsonTypeName = s.Name;
                DateProperty.ElementId = s.PropertyId;
                DateProperty.defaultLabel = s.Name;
                DateProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(DateProperty.JsonTypeName, DateProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(DateProperty, DatePropertyPeer, propsSectionLabel, "acd-icon-inputDate");
                hostContainers[0].elementsRegistry.register(DateProperty.JsonTypeName, DateProperty, AdaptiveCards.Versions.v1_4);
                break;
            case CustomPropertyDataType_LABELS.TIME:
                TimeProperty.JsonTypeName = s.Name;
                TimeProperty.ElementId = s.PropertyId;
                TimeProperty.defaultLabel = s.Name;
                TimeProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(TimeProperty.JsonTypeName, TimeProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(TimeProperty, TimePropertyPeer, propsSectionLabel, "acd-icon-inputTime");
                hostContainers[0].elementsRegistry.register(TimeProperty.JsonTypeName, TimeProperty, AdaptiveCards.Versions.v1_4);
                break;
             case CustomPropertyDataType_LABELS.LIST:
                ListProperty.JsonTypeName = s.Name;
                ListProperty.ElementId = s.PropertyId;
                ListProperty.defaultLabel = s.Name;
                ListProperty.customPropertyData = s;
                AdaptiveCards.GlobalRegistry.elements.register(ListProperty.JsonTypeName, ListProperty, AdaptiveCards.Versions.v1_4);
                ACDesigner.CardDesignerSurface.cardElementPeerRegistry.registerPeer(ListProperty, ListPropertyPeer, propsSectionLabel, "acd-icon-inputChoiceSet");
                hostContainers[0].elementsRegistry.register(ListProperty.JsonTypeName, ListProperty, AdaptiveCards.Versions.v1_4);
                break;
            default:
                break;
        }
    });
}

export function registerCardCustomComponents(featureSets: ACFeatureStates, currentState: AppStateValue) {
    AdaptiveCards.GlobalRegistry.elements.register(RequestTitle.JsonTypeName, RequestTitle, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(StatusPicker.JsonTypeName, StatusPicker, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(CategoryPicker.JsonTypeName, CategoryPicker, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(PriorityPicker.JsonTypeName, PriorityPicker, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(RequesterPeoplePicker.JsonTypeName, RequesterPeoplePicker, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(AddComment.JsonTypeName, AddComment, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(DueDate.JsonTypeName, DueDate, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(ResolutionDate.JsonTypeName, ResolutionDate, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(UploadFile.JsonTypeName, UploadFile, AdaptiveCards.Versions.v1_4);
    AdaptiveCards.GlobalRegistry.elements.register(CardPeoplePicker.JsonTypeName, CardPeoplePicker, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableTicketTags)
        AdaptiveCards.GlobalRegistry.elements.register(TagsTypeahead.JsonTypeName, TagsTypeahead, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableAffectedUsers)
        AdaptiveCards.GlobalRegistry.elements.register(AffectedUsersPeoplePicker.JsonTypeName, AffectedUsersPeoplePicker, AdaptiveCards.Versions.v1_4);
    
    if(featureSets.enableCollaborators)
        AdaptiveCards.GlobalRegistry.elements.register(CollaboratorsTypeahead.JsonTypeName, CollaboratorsTypeahead, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableMultiDepartment){
        AdaptiveCards.GlobalRegistry.elements.register(Assignment.JsonTypeName, Assignment, AdaptiveCards.Versions.v1_4);
        AdaptiveCards.GlobalRegistry.elements.register(TeamPicker.JsonTypeName, TeamPicker, AdaptiveCards.Versions.v1_4);
        AdaptiveCards.GlobalRegistry.elements.register(GroupPicker.JsonTypeName, GroupPicker, AdaptiveCards.Versions.v1_4);
    }

    if(featureSets.enableTicketTypes)
        AdaptiveCards.GlobalRegistry.elements.register(TicketTypePicker.JsonTypeName, TicketTypePicker, AdaptiveCards.Versions.v1_4);

    if(featureSets.enableCustomProperties){
        const customProperties = currentState?.customProperties ?? [];
        customProperties.forEach(s => {
            switch(CustomPropertyDataType_LABELS[s.DataType]){
                case CustomPropertyDataType_LABELS.STRING:
                    TextProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(TextProperty.JsonTypeName, TextProperty, AdaptiveCards.Versions.v1_4);
                    break;
                case CustomPropertyDataType_LABELS.INT:
                    NumProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(NumProperty.JsonTypeName, NumProperty, AdaptiveCards.Versions.v1_4);
                    break;
                case CustomPropertyDataType_LABELS.DATE:
                    DateProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(DateProperty.JsonTypeName, DateProperty, AdaptiveCards.Versions.v1_4);
                    break;
                case CustomPropertyDataType_LABELS.TIME:
                    TimeProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(TimeProperty.JsonTypeName, TimeProperty, AdaptiveCards.Versions.v1_4);
                    break;
                case CustomPropertyDataType_LABELS.BOOL:
                    BoolProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(BoolProperty.JsonTypeName, BoolProperty, AdaptiveCards.Versions.v1_4);
                    break;
                case CustomPropertyDataType_LABELS.LIST:
                    ListProperty.JsonTypeName = s.Name;
                    AdaptiveCards.GlobalRegistry.elements.register(ListProperty.JsonTypeName, ListProperty, AdaptiveCards.Versions.v1_4);
                    break;
                default:
                    break;
            }
        });
    }
}
